import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ConfigProvider } from "antd";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: "#006ab3", // main blue
        colorPrimaryHover: "#1a82c7", //  light blue for hover
        colorPrimaryActive: "#005a99", //  darker blue for active
      },
    }}
  >
    <App />
  </ConfigProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
